export const config = {
  partialUrls: {
    login: '/users/login',
    candidates: '/candidates',
    resumeDownloadsCounter: '/users/resumeDownloadsCounter',
    resumeDownloadsCountSend: '/users/resumeDownloadsCountSend',
    emailNotification: '/users/emailNotification',
    skills: '/skills',
    create: '/candidates/create',
    clients: '/clients',
    companies: '/clients/companies',
    operationBranches: '/clients/operation-branches',
    deleteCandidate: '/candidates/delete',
    updateCandidate: '/candidates/update',
    loginHistory: '/users/loginHistory',
    DownloadedActivity: '/users/downloadedActivity',
    getUsers: '/users/getUsersData',
    updateUsersStatus: '/users/usersStatus',
  },
};
